<div [formGroup]="form">

    <app-ativacao-section-card
        [control]="ativoControl"
        titulo="Monofásica Padrão"
        [exibirTituloNoAlerta]="false"
        descricaoAtivo="Modalidade padrão ativa. As alíquotas por unidade abaixo serão aplicadas na tributação monofásica."
        descricaoInativo="Modalidade padrão inativa. Ative para informar as alíquotas por unidade de IBS e CBS."
        emptyStateTitulo="Monofásica Padrão desativada"
        emptyStateDescricao="Ative a modalidade padrão acima para informar as alíquotas por unidade de IBS e CBS.">
    </app-ativacao-section-card>

    @if (ativoControl.value) {
    <div class="section-container">
        <div class="section-title">
            <mat-icon class="material-symbols-outlined">local_gas_station</mat-icon>
            <span>Monofásica Padrão</span>
            <div class="section-title-actions ms-auto">
                <button mat-button type="button" class="btn-section" [matBadge]="personalizadasCount" [matBadgeHidden]="personalizadasCount === 0" (click)="abrirEditorFormulas()">
                    <mat-icon class="material-symbols-outlined">settings</mat-icon>
                    Personalizar fórmulas
                </button>
            </div>
        </div>

        <div class="row g-3">
            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Alíquota por unidade IBS</mat-label>
                    <input matInput type="text" inputmode="numeric" [currencyMask]="currencyMask" formControlName="adRemIbs">
                    <mat-error>{{ form.get('adRemIbs')?.hasError('min') ? 'O ad rem do IBS do monofásico padrão não pode ser negativo.' : 'Informe o ad rem do IBS e da CBS do monofásico padrão.' }}</mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Alíquota por unidade CBS</mat-label>
                    <input matInput type="text" inputmode="numeric" [currencyMask]="currencyMask" formControlName="adRemCbs">
                    <mat-error>{{ form.get('adRemCbs')?.hasError('min') ? 'O ad rem da CBS do monofásico padrão não pode ser negativo.' : 'Informe o ad rem do IBS e da CBS do monofásico padrão.' }}</mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>
    }
</div>
